import React, { useEffect, useState } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Divider,
  InputLabel,
  Button,
  Card,
  TextField
} from "@mui/material";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import axios from "axios";
import { ReactComponent as BackArrrow } from "../../../Icons/BorderBackIcon.svg";
import { ReactComponent as FormIcon } from "../../../Icons/CommonFormIcon.svg";
import { useNavigate } from "react-router-dom";
import CheckIcon from '@mui/icons-material/Check';
import ClearIcon from '@mui/icons-material/Clear';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import {
  ServicesGetAll,
  OtherServicesGetAll,
} from "../../../Redux/Feature/CommonSlice";
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";
import FormatNumber from "../../../CommonComponents/FormatNumber";
import CheckListTable from "./CheckListTable";

export default function ViewCheckListRequest() {
  const { ServicesData, OtherServiceData } = useSelector((state) => state.CommonData);
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const [PersonalData, setPersonalData] = useState({});
  const [ServicesValue, setServicesValue] = useState({});
  const [RoomsData, setRoomsData] = useState({});
  const [created_at, setCreated_at] = useState(null);
  const [status, setStatus] = useState('')
  const [checkListData, setCheckListData] = useState({})
  const [comment, setComment] = useState('')

//   useEffect(() => {
//     dispatch(ServicesGetAll());
//     dispatch(OtherServicesGetAll());
//   }, [dispatch]);

//   const { Details, Emergency_contact } = PersonalData;
  const [loading, setLoading] = useState(true)

//   const {
//     otherServices,
//     fligt_no,
//     arrival_date,
//     arrival_time,
//     landingServices,
//   } = ServicesValue;

  const { id } = useParams();
  const getAllAnnouncement = async () => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}checklist-application/${id}`
      );
      setStatus(response?.data?.data?.status)
    //   setCreated_at(response?.data?.data?.createdAt);
    //   setRoomsData(response?.data?.data?.RoomsData);
    //   setServicesValue(response?.data?.data?.ServicesValue);
    //   setPersonalData(response?.data?.data?.PersonalData);
    setComment(response?.data?.data?.comments || "")
    setCheckListData(response?.data?.data)
      setLoading(false)
    } catch (error) {
      console.log(error);
      setLoading(false)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  console.log(checkListData)
  const handleAcceptRejectApplication = async (newState) => {
    await axiosInstance.put(`${process.env.REACT_APP_API_URL}checklist/update`, 
        { 
            student_id : id, 
            status : newState,
            comments : comment
        })
    .then((response) => {
      console.log(response)
      if(response.status === 200){
        navigate('/Admin/checklist')
        getAllAnnouncement()
      }
    })
    .catch((error) => {
      console.log(error)
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    })
  }


  useEffect(() => {
    getAllAnnouncement();
  }, []);

  if(loading){
    return <p>Loading...</p>
  }

  const FileDisplayCard = ({ bookedService, name, heading }) => {

    const images = [bookedService?.Details?.[name]];
    console.log(images)
  
    if (!images || !Array.isArray(images)) return null;
  
    return images.map((file, index) => {
      // const fileUrl = `/${file.path.replaceAll("\\", "/")}`;
      const isImage = file.mimetype?.startsWith("image");
  
      return (
        <Card key={index} sx={{ mt: 2, p: 2 }}>
          <Typography fontWeight="bold">{heading}</Typography>
  
          {isImage ? (
            <img
              src={`${process.env.REACT_APP_FILE_PATH}${file.filename}`}
              alt={file.originalname}
              style={{ maxWidth: "100%", marginTop: 8, borderRadius: 8 }}
            />
          ) : (
            <iframe
              src={`${process.env.REACT_APP_FILE_PATH}${file.filename}`}
              title={file.originalname}
              style={{ width: "100%", height: "300px", border: "1px solid #ccc", marginTop: 8 }}
            ></iframe>
          )}
        </Card>
      );
    });
  };

console.log(PersonalData)

  return (
    <Box pb={30} px={{ md: 10, xs: 3 }}>
      <Box>
        <BackArrrow
          onClick={() => navigate("/Admin/checklist")}
          style={{ cursor: "pointer", marginBottom: "20px" }}
        />
        <Typography variant="h6_1">Checklist Information</Typography>
        {/* <Typography>
          {`Signed At :${" "}${moment(checkListData?.signed_Date).format(
            "DD MMM YYYY, HH:mm A"
          )}`}
        </Typography> */}
      </Box>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          backgroundColor: "#FCFCFD",
          border: "1px solid #E5E7EB",
          padding: "20px",
          borderRadius: "6px 6px 0px 0px",
          marginTop: "20px",
        }}
      >
        <FormIcon style={{ marginRight: "10px" }} />
        <Typography variant="h7_1">Requester Information</Typography>
      </Stack>
      <Grid
        container
        xs={12}
        gap="2.8%"
        sx={{
          backgroundColor: "white",
          padding: "20px",
          borderBottom: "1px solid #E5E7EB",
          borderRight: "1px solid #E5E7EB",
          borderLeft: "1px solid #E5E7EB",
        }}
      >
        <Grid xs={12} sm={5.8} my={2}>
          <Typography
            sx={{
              color: "#6C737F",
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
            Student Name
          </Typography>
          <Typography
            sx={{
              color: "#111927",
              fontSize: "16px",
              fontWeight: 600,
            }}
            mt={0.5}
          >
            {checkListData?.student?.userData?.name}
          </Typography>
        </Grid>
        <Grid xs={12} sm={5.8} my={2}>
          <Typography
            sx={{
              color: "#6C737F",
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
            Email
          </Typography>
          <Typography
            sx={{
              color: "#111927",
              fontSize: "16px",
              fontWeight: 600,
            }}
            mt={0.5}
          >
            {checkListData?.student?.email}
          </Typography>
        </Grid>
        {/* <Divider
          sx={{
            borderTop: "1px solid #F3F4F6",
            width: "100%",
            marginTop: "10px",
          }}
        /> */}
        
      </Grid>
      <Stack
        direction="row"
        alignItems="center"
        sx={{
          backgroundColor: "#FCFCFD",
          border: "1px solid #E5E7EB",
          borderTop: "none",
          padding: "20px",
        }}
      >
        <FormIcon style={{ marginRight: "10px" }} />
        <Typography variant="h7_1">Requested Items</Typography>
      </Stack>
      <CheckListTable checklistItems={checkListData?.checklistItems}/>
      

      <TextField 
            sx={{mt : 2}}
            multiline
            rows={4}
            placeholder="Comments to user if application gets rejected (Optional)"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
      />
      
      
      
      
     
      

      {/* {PersonalData?.Details?.ipaFile && (
            <FileDisplayCard bookedService={PersonalData} name={'ipaFile'} heading={'IPA'}/>
        )}

            {PersonalData?.Details?.passport && (
            <FileDisplayCard bookedService={PersonalData} name={'passport'} heading={'Passport'}/>
        )} */}

      <Box sx={{mt : 5, padding : '10px', display : 'flex', justifyContent : 'space-between', alignItems : 'center'}}>
        <Box sx={{display : 'flex', gap : '5px'}}>
          <Typography sx={{fontWeight : 700, fontSize : '16px'}}>Current Status</Typography>
          <Typography>:</Typography>
          <Typography sx={{ fontSize: '16px' }}>
  {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase() == "Success" ? "Accepted" : status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
</Typography>

        </Box>

        <Box sx={{gap : '10px', display : 'flex'}}>
        {/* <Button onClick={() => {
            handleAcceptRejectApplication('pending')
        }} endIcon={<HourglassEmptyIcon />} disabled={status === 'pending'} variant='contained'>Pending</Button> */}

        <Button onClick={() => {
          handleAcceptRejectApplication('failed')
        }} endIcon={<ClearIcon />} disabled={status === 'failed'} variant='contained'>Reject</Button>

        <Button onClick={() => {
            handleAcceptRejectApplication('completed')
        }} endIcon={<CheckIcon />} disabled={status === 'completed'} variant='contained'>Accept</Button>
        </Box>
      </Box>
    </Box>
  );
}
